import { render, staticRenderFns } from "./TopList.vue?vue&type=template&id=c243a99a&scoped=true"
import script from "./TopList.vue?vue&type=script&lang=js"
export * from "./TopList.vue?vue&type=script&lang=js"
import style0 from "./TopList.vue?vue&type=style&index=0&id=c243a99a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c243a99a",
  null
  
)

export default component.exports